/**
 * Custom Joyride tooltip component.
 * Shows step progress, friendly copy, and navigation buttons.
 */

export default function TourTooltip({
  continuous,
  index,
  step,
  size,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  isLastStep,
  tooltipProps,
}) {
  const progress = ((index + 1) / size) * 100;
  console.log("[TourTooltip] Rendering tooltip for step:", index);

  return (
    <div {...tooltipProps} className="tour-tooltip" style={{ position: 'relative' }}>
      {/* Progress bar */}
      <div className="tour-tooltip__progress-bar">
        <div
          className="tour-tooltip__progress-fill"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Close button */}
      <button
        {...closeProps}
        className="tour-tooltip__close"
        aria-label="Close tour"
      >
        ×
      </button>

      {/* Body */}
      <div className="tour-tooltip__body">
        {step.title && (
          <h3 className="tour-tooltip__title">{step.title}</h3>
        )}
        {(step.content || step.fallbackContent) ? (
          <p className="tour-tooltip__content">{step.content || step.fallbackContent}</p>
        ) : (
          <p className="tour-tooltip__content">Here's a tip to help you in this section!</p>
        )}
      </div>

      {/* Footer */}
      <div className="tour-tooltip__footer">
        <span className="tour-tooltip__step-counter">
          Step {index + 1} of {size}
        </span>

        <div className="tour-tooltip__actions">
          {!isLastStep && (
            <button
              {...skipProps}
              className="tour-tooltip__btn tour-tooltip__btn--skip"
            >
              Skip
            </button>
          )}

          {index > 0 && (
            <button
              {...backProps}
              className="tour-tooltip__btn tour-tooltip__btn--back"
            >
              Back
            </button>
          )}

          {continuous && (
            <button
              {...primaryProps}
              className="tour-tooltip__btn tour-tooltip__btn--next"
            >
              {isLastStep ? 'Finish' : 'Next →'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
